import $ from "cash-dom";

import { setLoadingCards, fetchMoreCards, updatepageObservers, setMakeModel  } from "./functions.js";

$(function () {
  $('#load-more-bottom').on('click', function () {
    if (!activeRequest) {
      activeRequest = true;
      const urlParams = new URLSearchParams(window.location.search);

      let page = $('[data-page]').last().data('page');
      page++;
      urlParams.set("page", page);

      if (page == window.totalPages) {
        $('#load-more-div-bottom').addClass('is-hidden');
      }
      
      setMakeModel(urlParams);

      const endpoint = `${location.protocol}//${location.host}/cars-for-sale/api/v2/cars?${urlParams.toString()}`;

      setLoadingCards();
      fetchMoreCards(endpoint, page).finally(() => {
        activeRequest = false;
      });
    }
  });
  
  $('#load-more-top').on('click', function () {
    if (!activeRequest) {
      activeRequest = true;

      const urlParams = new URLSearchParams(window.location.search);

      let page = $('[data-page]').first().data('page');
      page--;
      urlParams.set("page", page);

      if (page === 1){
        $('#load-more-div-top').addClass('is-hidden');
      }
      
      setMakeModel(urlParams);

      const endpoint = `${location.protocol}//${location.host}/cars-for-sale/api/v2/cars?${urlParams.toString()}`;

      setLoadingCards('previous');

      fetchMoreCards(endpoint, page, 'previous').finally(() => {
        activeRequest = false;
      });

    }
  });

  updatepageObservers()
});
